import { didomiConfig, forbiddenPages } from '../constants'
let _onDOMContentLoaded: (() => void) | null = null

export default {
  onReady(cb: () => void) {
    window.didomiOnReady.push(cb)
  },
  init() {
    window.didomiOnReady = window.didomiOnReady || []
    if (document.readyState !== 'loading') {
      this.load()
    } else {
      _onDOMContentLoaded = this.load.bind(this)
      document.addEventListener('DOMContentLoaded', _onDOMContentLoaded)
    }
  },
  load() {
    window.didomiConfig = didomiConfig
    const bodyClasses = document.body.className
    if (bodyClasses.match(forbiddenPages) == null) {
      window.gdprAppliesGlobally = true
      ;(function () {
        function getTypeof(something: any) {
          return typeof something
        }
        function r() {
          if (!window.frames?.__cmpLocator) {
            if (document.body && document.body.firstChild) {
              const e = document.body
              const t = document.createElement('iframe')
              t.style.display = 'none'
              t.name = '__cmpLocator'
              t.title = 'cmpLocator'
              e.insertBefore(t, e.firstChild)
            } else {
              setTimeout(r, 5)
            }
          }
        }
        function e(e: any, t: any, r: any) {
          if (typeof r !== 'function') {
            return
          }
          if (!window.__cmpBuffer) {
            window.__cmpBuffer = []
          }
          if (e === 'ping') {
            r(
              {
                gdprAppliesGlobally: window.gdprAppliesGlobally,
                cmpLoaded: false,
              },
              true,
            )
          } else {
            window.__cmpBuffer.push({ command: e, parameter: t, callback: r })
          }
        }
        e.stub = true
        function t(a: any) {
          if (!window.__cmp || window.__cmp.stub !== true) {
            return
          }
          if (!a.data) {
            return
          }
          const n = typeof a.data === 'string'
          let e
          try {
            e = n ? JSON.parse(a.data) : a.data
          } catch {
            return
          }
          if (e.__cmpCall) {
            const o = e.__cmpCall
            window.__cmp(o.command, o.parameter, function (e: any, t: any) {
              const r = {
                __cmpReturn: { returnValue: e, success: t, callId: o.callId },
              }
              a.source.postMessage(n ? JSON.stringify(r) : r, '*')
            })
          }
        }
        if (getTypeof(window.__cmp) !== 'function') {
          window.__cmp = e
          if (window.addEventListener) {
            window.addEventListener('message', t, false)
          } else {
            window.attachEvent('onmessage', t)
          }
        }
        r()
      })()
      ;(function (e, t) {
        const r = document.createElement('script')
        r.id = 'spcloader'
        r.type = 'text/javascript'
        r.async = true
        r.src =
          'https://sdk.privacy-center.org/' +
          e +
          '/loader.js?target_type=notice&target=' +
          t
        r.charset = 'utf-8'
        const a = document.getElementsByTagName('script')[0]
        a.parentNode?.insertBefore(r, a)
      })('40417c5a-7e8d-476d-a9c8-9dd9af934316', '2yqNqzpf')
      if (_onDOMContentLoaded) {
        document.removeEventListener('DOMContentLoaded', _onDOMContentLoaded)
        _onDOMContentLoaded = null
      }
    }
  },
  hasConsent(consent: string) {
    return window.Didomi?.getUserConsentStatus(
      window.Didomi.Purposes.Cookies,
      consent,
    )
  },
  showPreferences() {
    window.Didomi?.preferences.show()
  },
}
